import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { media } from "utils/style";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import CommonContainer from "common-components/Container";
import StyledLink from "common-components/StyledLink";

class FormerCustomerDeleteConfirmation extends Component {

  componentDidMount() {
    if (checkNestedObject(this.props, "location", "state", "deleteConfirmationContent")) {
      this.props.setA11yContent(
        "former delete confirmation",
        this.props.location.state.deleteConfirmationContent.sc_pagetitle
      );
    }

    const authTokenString = window.location.search;
    const { skipVerification, history } = this.props;
    const el = document.getElementById('return_delete_primer');
    if (el) {
      el.addEventListener("click", function () {
        if (skipVerification) {
          history.push("/privacy/your-data/former-customer/your-deletable" + authTokenString);
        } else {
          history.push("/privacy/your-data/former-customer/");
        }
      });
    }
  }

  render() {

    if (!checkNestedObject(this.props, "location", "state", "deleteConfirmationContent")) {
      return <Redirect to="/privacy/your-data/former-customer" />;
    }

    const { deleteConfirmationContent, nextRoute } = this.props.location.state
    const {
      section_title,
      buttons,
      section_description
    } = deleteConfirmationContent;


    return (
      <Container>
        <div style={{ maxWidth: "596px" }}>
          <Header>{convertStringToElements(section_title)}</Header>
          <Div>{convertStringToElements(section_description)}</Div>
          <StyledLink
            background={buttons[0].type}
            style={{ marginTop: "16px" }}
            to={nextRoute}
          >
            {buttons[0].text}
          </StyledLink>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent
}) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent, setBreadcrumbList }
)(FormerCustomerDeleteConfirmation);

const Div = styled.div`
  margin-top: 28px;
  margin-bottom:55px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  max-width: 490px;

  p {
    margin: 12px 0;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;

    :nth-child(2) {
      font-weight: 700;

      a { 
        font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif !important;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  #return_delete_primer  {
    text-decoration: underline;
    border: transparent;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;
    font-weight: 700;
  }

  #return_delete_primer:focus, #return_delete_primer.focus {
   outline: none !important;
  }
`;

const Header = styled.h1`
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  max-width: 486px;

  ${media.mobile`
    font-size: 32px;	
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  `}
`;

const Container = styled(CommonContainer)`
  margin: "0px 0px 0px 20px";
  padding: 47px 20px ;
  ${media.mobile`
  margin: "0";
  padding: 48px 16px ;
  `}
`;
